<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-lg-8">

      <h1 class="display-6 fw-bold mb-2">Cookie Policy</h1>
      <p class="text-body-secondary mb-4">Last updated: March 2026</p>
      <hr>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">1. What Are Cookies</h2>
        <p>Cookies are small text files stored on your device when you visit a website. They help the website remember your preferences and improve your experience.</p>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">2. How We Use Cookies</h2>
        <p>Vocabulary uses cookies strictly for the operation and security of the Service. We categorise them as follows:</p>

        <div class="card mb-3">
          <div class="card-header fw-semibold">Essential Cookies (Strictly Necessary)</div>
          <div class="card-body">
            <p class="card-text small">These cookies are required for the Service to function and do not require consent under GDPR (<a href="https://gdpr-info.eu/art-5-gdpr/" target="_blank" rel="noopener">Art. 5(3)</a> of the <a href="https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:32002L0058" target="_blank" rel="noopener">ePrivacy Directive</a>).</p>
            <ul class="list-group list-group-flush">
              <li class="list-group-item"><strong>Authentication cookies:</strong> set by Keycloak to manage your login session, verify your identity, and maintain your authenticated state.</li>
              <li class="list-group-item"><strong>Session cookies:</strong> used to maintain your session as you navigate the application.</li>
              <li class="list-group-item"><strong>Security cookies:</strong> used to support HTTPS enforcement and protect against cross-site request forgery (CSRF).</li>
            </ul>
          </div>
        </div>

        <div class="card mb-3">
          <div class="card-header fw-semibold">Functional Cookies</div>
          <div class="card-body">
            <p class="card-text small mb-0">These cookies remember your preferences, such as language settings and display options, to provide a personalised experience. They are set based on actions you take (e.g. selecting a language).</p>
          </div>
        </div>

        <div class="card mb-3">
          <div class="card-header fw-semibold">Analytics Cookies (Requires Consent)</div>
          <div class="card-body">
            <p class="card-text small">These cookies are set only if you give your consent via the cookie banner. They help us understand how visitors interact with the Service so we can improve it.</p>
            <ul class="list-group list-group-flush">
              <li class="list-group-item"><strong>_ga:</strong> Google Analytics — distinguishes unique users. Expires after 2 years.</li>
              <li class="list-group-item"><strong>_ga_*:</strong> Google Analytics — stores session state. Expires after 2 years.</li>
            </ul>
          </div>
        </div>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">3. Keycloak (Authentication Provider) Cookies</h2>
        <p>Our identity provider, Keycloak, sets cookies necessary for the authentication process. These are essential cookies required for login and session management. They are transmitted exclusively over HTTPS and are scoped to the authentication domain.</p>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">4. Google Analytics</h2>
        <p>With your consent, we use Google Analytics 4 (provided by Google LLC) to collect anonymised usage data such as pages visited and session duration. Google may process this data on servers outside the EEA. For more information, see <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Google's Privacy Policy</a>.</p>
        <p>You can withdraw your consent at any time by clicking <strong>Reject</strong> in the cookie banner (clear your browser cookies to reset your preference and see the banner again).</p>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">5. What We Do Not Use</h2>
        <div class="alert alert-light border">
          <ul class="mb-0">
            <li>Advertising or retargeting cookies.</li>
            <li>Social media cookies.</li>
          </ul>
        </div>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">6. Data Transmitted via Cookies</h2>
        <p>All cookies are transmitted over HTTPS (encrypted connections only). Cookies used for authentication contain session identifiers and do not store your password or personal data directly. For details on how we process personal data, see our <a routerLink="/privacy">Privacy Policy</a>.</p>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">7. Managing Cookies</h2>
        <p>You can control and delete cookies through your browser settings. Please note that disabling essential cookies will prevent you from logging in and using the Service.</p>
        <table class="table table-sm table-bordered">
          <thead class="table-light">
            <tr>
              <th>Browser</th>
              <th>Path</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Chrome</td>
              <td>Settings &gt; Privacy and security &gt; Cookies</td>
            </tr>
            <tr>
              <td>Firefox</td>
              <td>Settings &gt; Privacy &amp; Security &gt; Cookies</td>
            </tr>
            <tr>
              <td>Safari</td>
              <td>Preferences &gt; Privacy</td>
            </tr>
            <tr>
              <td>Edge</td>
              <td>Settings &gt; Cookies and site permissions</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section>
        <h2 class="h5 fw-semibold">8. Changes to This Policy</h2>
        <p>We may update this cookie policy from time to time. Any changes will be reflected on this page with an updated revision date.</p>
      </section>

    </div>
  </div>
</div>
